export default "__VITE_ASSET__p0VVF2Jo__"